import { apiRequest } from "../api.jsx";

export const getMyOrders = () => apiRequest("/orders/me");

export const cancelMyOrder = (orderId, reason) =>
  apiRequest(`/order/${encodeURIComponent(orderId)}/cancel`, "PUT", { reason });

export const requestMyOrderReturn = (orderId, reason) =>
  apiRequest(`/order/${encodeURIComponent(orderId)}/return`, "POST", { reason });
